<template>
  <div class="cd-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="订单类型">
              <el-select v-model="searchForm.type" style="width: 120px" filterable clearable @keyup.enter.native="Search">
                <el-option-group label="">
                  <el-option label="正单" :value="0" />
                  <el-option label="补单" :value="5" />
                </el-option-group>
                <el-option-group label="补单类型">
                  <el-option label="客改单" :value="1" />
                  <el-option label="增补单" :value="2" />
                  <el-option label="色板单" :value="3" />
                  <el-option label="售后单" :value="4" />
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="品牌">
              <el-select v-model="searchForm.brandId" style="width: 120px" filterable clearable @keyup.enter.native="Search">
                <el-option v-for="brand in brandList" :key="brand.brand_id" :label="brand.brand_name" :value="brand.brand_id" />
              </el-select>
            </el-form-item>
            <el-form-item label="核对情况">
              <el-select v-model="searchForm.chk" style="width: 120px" filterable clearable @keyup.enter.native="Search">
                <el-option label="未核对" :value="0" />
                <el-option label="已核对" :value="1" />
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item style="float: right; position: relative; z-index: 99;">
              <el-button-group>
                <el-button :type="mark===6?'primary':''" size="small" @click="changeMark(6)">待拆单</el-button>
                <el-button :type="mark===7?'primary':''" size="small" @click="changeMark(7)">已拆单</el-button>
              </el-button-group>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col v-loading="loading" :span="24">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  style="width: 100%"
                  @row-click="openDetails"
                >
                  <el-table-column
                    label="订单号"
                    width="140"
                    fixed
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.order_num }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="经销商"
                    width="120"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span :style="scope.row.all_name && scope.row.all_name.indexOf('VIP') > -1 ? 'font-weight: bold; color: #389e0d; font-style: italic;' : ''">
                        {{ scope.row.all_name }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单类型"
                    width="110"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.mark===0">正单</span>
                      <span v-if="scope.row.mark===1">客改单</span>
                      <span v-if="scope.row.mark===2">增补单</span>
                      <span v-if="scope.row.mark===3">色板单</span>
                      <span v-if="scope.row.mark===4">售后单</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单性质"
                    width="110"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.nature===0">家装</span>
                      <span v-if="scope.row.nature===1">展厅</span>
                      <span v-if="scope.row.nature===2">工程</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="品牌"
                    width="130"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.brand_name }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="分配时间"
                    width="170"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.allot_time }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="mark===6?'预计完成时间':'完成时间'"
                    :width="220"
                    align="center"
                    fixed="right"
                  >
                    <template slot-scope="scope">
                      <div v-if="scope.row.preSplit " style="display: flex; flex-direction: column; align-items: center;">
                        <span>{{ scope.row.preSplit }}</span>
                        <span v-if="scope.row.preHours"
                          style="color: #F56C6C; font-weight: bold;"
                          :style="scope.row.preHours.indexOf('还剩0天') > -1 ? 'color: #E6A23C;' : (scope.row.preHours.indexOf('还剩') > -1 ? 'color: #67C23A;' : '')">
                          {{ scope.row.preHours }}
                        </span>
                        <span v-else style="color:#999999;">--</span>
                        <!-- <div class="view-info" style="border-top: 1px solid #eaeff8; margin-top: 5px; padding-top: 5px;">
                          <div class="tit">
                            拆单耗时：
                            <span v-if="scope.row.splitTake" style="color: #409EFF;">{{ tranfromSec(scope.row.splitTake) }}</span>
                            <span v-else>--</span>
                          </div>
                          <div class="tit">
                            暂停时长：
                            <span v-if="scope.row.splitPauseTake" style="color: #E6A23C;">{{ tranfromSec(scope.row.splitPauseTake) }}</span>
                            <span v-else>--</span>
                          </div>
                        </div>
                      </div>
                      <div v-else class="view-info">
                        <div class="tit">
                          拆单耗时：
                          <span v-if="scope.row.splitTake" style="color: #409EFF;">{{ tranfromSec(scope.row.splitTake) }}</span>
                          <span v-else>--</span>
                        </div>
                        <div class="tit">
                          暂停时长：
                          <span v-if="scope.row.splitPauseTake" style="color: #E6A23C;">{{ tranfromSec(scope.row.splitPauseTake) }}</span>
                          <span v-else>--</span>
                        </div> -->
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="详细地址"
                    min-width="200"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.address }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="拆单人员"
                    align="center"
                    fixed="right"
                    width="110"
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.splitname }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="核对情况"
                    width="80"
                    fixed="right"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.chk==0" :disable-transitions="true" size="mini" type="warning">未核对</el-tag>
                      <el-tag v-if="scope.row.chk==1" :disable-transitions="true" size="mini">已核对</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="状态"
                    width="80"
                    fixed="right"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.status===6&&scope.row.type===4" :disable-transitions="true" size="mini" type="danger">确认驳回</el-tag>
                      <el-tag v-if="scope.row.status===6&&scope.row.type===8" :disable-transitions="true" size="mini" type="danger">审单驳回</el-tag>
                      <el-tag v-if="scope.row.status===6&&scope.row.type!==4&&scope.row.type!==8&&mark===6" :disable-transitions="true" size="mini" type="warning">待拆单</el-tag>
                      <el-tag v-if="scope.row.status===6&&scope.row.type!==4&&scope.row.type!==8&&mark===7" :disable-transitions="true" size="mini" type="warning">待审单</el-tag>
                      <el-tag v-if="scope.row.status===7" :disable-transitions="true" size="mini">已拆单</el-tag>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column
                    label="拆单状态"
                    width="110"
                    fixed="right"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.splitStatus===0" :disable-transitions="true" size="mini" type="warning">未开始</el-tag>
                      <el-tag v-if="scope.row.splitStatus===1" :disable-transitions="true" size="mini" type="primary">进行中</el-tag>
                      <el-tag v-if="scope.row.splitStatus===2" :disable-transitions="true" size="mini" type="danger">已暂停</el-tag>
                      <el-tag v-if="scope.row.splitStatus===3" :disable-transitions="true" size="mini" type="warning">待拆单员确认</el-tag>
                      <el-tag v-if="scope.row.splitStatus===4" :disable-transitions="true" size="mini" type="success">已完成</el-tag>
                    </template>
                  </el-table-column> -->
                  <el-table-column
                    v-if="mark===6"
                    width="210"
                    fixed="right"
                    align="left"
                    label="操作"
                  >
                    <template slot-scope="scope">
                      <el-row>
                        <el-col :span="24">
                          <el-button v-if="scope.row.splitStatus == 1" style="margin: 6px 8px 6px 0;" size="mini" icon="el-icon-copy-document" @click.stop="splitCf(scope.row)">拆分</el-button>
                          <el-button v-if="!scope.row.preSplit" style="margin: 6px 8px 6px 0;" plain size="mini" icon="el-icon-check" type="primary" @click.stop="expect(scope.row)">预计完成</el-button>
                          <el-button v-if="scope.row.splitStatus == 1" style="margin: 6px 8px 6px 0;" plain size="mini" icon="el-icon-edit-outline" type="primary" :disabled="nextOrdersLoading" @click.stop="split(scope.row)">拆单完成</el-button>
                          <el-button v-if="scope.row.chk == 0" style="margin: 6px 8px 6px 0;" plain size="mini" icon="el-icon-check" type="success" @click.stop="check(scope.row)">核对</el-button>
                          <!-- <el-button v-if="scope.row.splitStatus == 3" style="margin: 6px 8px 6px 0;" plain size="mini" icon="el-icon-video-play" type="success" @click.stop="start(scope.row)">继续拆单</el-button> -->
                          <!-- <el-button v-if="scope.row.splitStatus == 1" style="margin: 6px 8px 6px 0;" plain size="mini" icon="el-icon-video-pause" type="warning" :disabled="nextOrdersLoading" @click.stop="pause(scope.row)">暂停拆单</el-button> -->
                        </el-col>
                      </el-row>
                    </template>
                  </el-table-column>
                  <el-table-column
                    v-if="mark===7"
                    width="120"
                    fixed="right"
                    align="left"
                    label="操作"
                  >
                    <template slot-scope="scope">
                      <!-- <el-button plain size="mini" icon="el-icon-edit-outline" @click.stop="split(scope.row)"><span v-if="mark===6">拆单</span><span v-if="mark===7">拆单</span></el-button> -->
                      <el-button v-if="scope.row.chk == 0" plain size="mini" icon="el-icon-check" type="success" @click.stop="check(scope.row)">核对</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                >
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="拆单"
      :visible.sync="editVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="editForm" :model="editForm" :rules="editRules" label-position="right" label-width="90px" size="small">
        <el-form-item label="操作订单" prop="ordername">
          <el-input v-model="editForm.ordername" :disabled="true">
            <template slot="append"><el-button size="small" icon="el-icon-download" type="text" style="color: #20a0ff;padding:0 10px;font-size: 12px;" @click="downNewestTemplate">下载最新料单模板</el-button></template>
          </el-input>
        </el-form-item>
        <el-form-item label="料单导入" prop="fileid">
          <SingleFile :key="fileLoad" v-model="editForm.fileid" :accept="'.xls'" :old="oldFile" :tip="'只能上传Excel，文件上传后请导入'"></SingleFile>
        </el-form-item>
        <el-form-item label="料单状态" prop="splitFileid">
          <el-tag v-if="editForm.splitFileid!==null&&editForm.splitFileid!==''&&editForm.splitFileid!==undefined" type="success" :disable-transitions="true">料单已导入</el-tag>
          <el-tag v-if="(editForm.fileid===null||editForm.fileid===''||editForm.fileid===undefined)&&(editForm.splitFileid===null||editForm.splitFileid===''||editForm.splitFileid===undefined)" type="danger" :disable-transitions="true">未上传料单</el-tag>
          <el-tag v-if="editForm.fileid!==null&&editForm.fileid!==''&&editForm.fileid!==undefined&&(editForm.splitFileid===null||editForm.splitFileid===''||editForm.splitFileid===undefined)" type="warning" :disable-transitions="true">未导入料单</el-tag>
          <el-button v-if="editForm.splitFileid!==null&&editForm.splitFileid!==''&&editForm.splitFileid!==undefined" icon="el-icon-document-checked" @click="getMaterialDetail">查看导入详情</el-button>
          <el-popconfirm v-if="editForm.fileid!==null&&editForm.fileid!==''&&editForm.fileid!==undefined" :key="importKey" title="确认导入此料单吗？" @onConfirm="importMaterials">
            <el-button slot="reference" :loading="importloading" icon="el-icon-finished">导入料单</el-button>
          </el-popconfirm>
        </el-form-item>
        <el-form-item label="拆单备注" prop="content">
          <el-input v-model="editForm.content" type="textarea" maxlength="200" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="附属文件" prop="files">
          <MultiFile v-model="editForm.files"></MultiFile>
        </el-form-item>
        <el-form-item label="附属图片" prop="imgids">
          <MultiImg v-model="editForm.imgids" :size="'sm'"></MultiImg>
        </el-form-item>
        <!-- <el-form-item label="下一拆单订单" prop="nextOrderId" label-width="105px">
          <el-select
            v-model="editForm.nextOrderId"
            placeholder="请选择订单，可输入关键字搜索"
            filterable
            clearable
            prefix-icon="el-icon-search"
            style="width: 100%;">
            <el-option v-for="(item, index) in selectNextOrderList" :key="index" :value="item.order_id"
              :label="item.order_num + ' / ' + item.all_name + ' / ' + item.address">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item style="text-align: right;">
          <el-popconfirm :key="btnKey" title="已经确认这份料单导入正确，是否继续？" placement="top" width="200" @onConfirm="subEdit('editForm')">
            <el-button slot="reference" type="primary" :loading="editloading">拆单完成</el-button>
          </el-popconfirm>
          <el-button style="margin-left: 10px" @click="editVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="料单导入详情"
      :visible.sync="materialVisible"
      width="80%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :before-close="closeMaterial"
      :append-to-body="true"
    >
      <div v-loading="materialloading" style="height: 490px;width: 100%">
        <pl-table
          height="490px"
          :datas="materialTableData"
          :data="materialTableData"
          border
          size="small"
          use-virtual
          :pagination-show="false"
          :row-height="45"
        >
          <el-table-column prop="xuhao" label="序号" width="80" show-overflow-tooltip fixed></el-table-column>
          <el-table-column prop="area" label="区域" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="type" label="分类" width="80" show-overflow-tooltip></el-table-column>
          <el-table-column prop="name" label="名称" width="160" show-overflow-tooltip></el-table-column>
          <el-table-column prop="material" label="基材" width="80" show-overflow-tooltip></el-table-column>
          <el-table-column prop="high" label="高/长" width="70" show-overflow-tooltip></el-table-column>
          <el-table-column prop="width" label="宽" width="70" show-overflow-tooltip></el-table-column>
          <el-table-column prop="lwidth" label="L宽" width="70" show-overflow-tooltip></el-table-column>
          <el-table-column prop="ply" label="厚" width="70" show-overflow-tooltip></el-table-column>
          <el-table-column prop="num" label="数量" width="70" show-overflow-tooltip></el-table-column>
          <el-table-column prop="val" label="数值" width="70" show-overflow-tooltip></el-table-column>
          <el-table-column prop="unit" label="单位" width="70" show-overflow-tooltip></el-table-column>
          <el-table-column prop="color" label="颜色" width="140" show-overflow-tooltip></el-table-column>
          <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip></el-table-column>
        </pl-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="materialTableData=[],materialVisible=false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="拆分订单"
      :visible.sync="editSplitVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="editSplitForm" :model="editSplitForm" :rules="editSplitRules" label-position="right" label-width="90px" size="small">
        <el-form-item label="操作订单" prop="ordername">
          <el-input v-model="editSplitForm.ordername" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="拆分个数" prop="num">
          <el-input-number v-model="editSplitForm.num" :min="2" :max="10" @change="handleSplitChange"></el-input-number>
          <span style="color:#99a9bf;font-size: 12px;margin-left: 10px">最少拆分2个，最多不超过10个</span>
        </el-form-item>
        <el-form-item v-for="(item, index) in editSplitForm.orderInfo" :key="item.key" :label="'订单'+(index+1)" :prop="'orderInfo.' + index +'.address'" :rules="editSplitRules.address">
          <el-input v-model="item.address" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editSplitloading" @click="subSplitEdit('editSplitForm')">立即提交</el-button>
          <el-button @click="editSplitVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="预计拆单完成时间"
      :visible.sync="expectSplitVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="expectSplitForm" :model="expectSplitForm" :rules="expectSplitRules" label-position="right" label-width="100px" size="small">
        <el-form-item label="操作订单" prop="ordername">
          <el-input v-model="expectSplitForm.ordername" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="预计完成时间" prop="time">
          <el-date-picker
            v-model="expectSplitForm.time"
            type="datetime"
            placeholder="选择日期时间"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            default-time="12:00:00">
          </el-date-picker>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="expectSplitloading" @click="subSplitExpect('expectSplitForm')">立即提交</el-button>
          <el-button @click="expectSplitVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="暂停拆单"
      :visible.sync="pauseSplitVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="pauseSplitForm" :model="pauseSplitForm" :rules="pauseSplitRules" label-position="right" label-width="100px" size="small">
        <el-form-item label="操作订单" prop="ordername">
          <el-input v-model="pauseSplitForm.ordername" :disabled="true"></el-input>
        </el-form-item>
        <el-alert style="margin-bottom: 20px;" title="提示" type="info"
          description="备注内容、凭证图片二选一填写即可" :closable="false" show-icon>
        </el-alert>
        <el-form-item label="备注内容" prop="content">
          <el-input v-model="pauseSplitForm.content" type="textarea" maxlength="300" show-word-limit />
        </el-form-item>
        <el-form-item label="凭证图片" prop="imgids">
          <MultiImg v-model="pauseSplitForm.imgids" :size="'sm'"></MultiImg>
        </el-form-item>
        <el-form-item label="下一拆单订单" prop="nextOrderId" label-width="105px">
          <el-select
            v-model="pauseSplitForm.nextOrderId"
            placeholder="请选择订单，可输入关键字搜索"
            filterable
            clearable
            prefix-icon="el-icon-search"
            style="width: 100%;">
            <el-option v-for="(item, index) in selectNextOrderList" :key="index" :value="item.order_id"
              :label="item.order_num + ' / ' + item.all_name + ' / ' + item.address">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="pauseSplitLoading" @click="subSplitPause('pauseSplitForm')">立即暂停</el-button>
          <el-button @click="pauseSplitVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="请选择正在拆单中订单"
      :visible.sync="nextSplitVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-alert
        style="margin-bottom: 20px;"
        title="提示"
        type="warning"
        description="系统检测到当前无进行中的拆单，请先选择当前正在拆单的订单！"
        :closable="false"
        show-icon>
      </el-alert>
      <el-form ref="nextSplitForm" :model="nextSplitForm" :rules="nextSplitRules" label-position="right" label-width="100px" size="small">
        <el-form-item label="正在拆单订单" prop="nextOrderId" label-width="105px">
          <el-select
            v-model="nextSplitForm.nextOrderId"
            placeholder="请选择订单，可输入关键字搜索"
            filterable
            clearable
            prefix-icon="el-icon-search"
            style="width: 100%;">
            <el-option v-for="(item, index) in selectNextOrderList" :key="index" :value="item.order_id"
              :label="item.order_num + ' / ' + item.all_name + ' / ' + item.address">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="nextSplitLoading" @click="subSplitNext('nextSplitForm')">确认选择</el-button>
          <el-button @click="nextSplitVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getOrderList, ErpOrderImportMaterial, getErpOrderMaterialDetail, splitCarryOrder, orderSplit, getNewestMaterialTemplate, chkOrder, expectSplit, addOrderDynamic, getSplitInfo } from '@/api/erp'
import MultiFile from '@/components/upload/MultiFile'
import MultiImg from '@/components/upload/MultiImg'
import SingleFile from '@/components/upload/SingleFile'
import { getBrandList } from '@/api/work'

export default {
  name: 'Cd',
  components: {
    MultiFile,
    MultiImg,
    SingleFile
  },
  data() {
    return {
      mark: 6,
      istempFile: false,
      fileLoad: '',
      btnKey: '',
      importKey: '',
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editVisible: false,
      editloading: false,
      importloading: false,
      oldFile: [],
      materialVisible: false,
      materialloading: false,
      materialTableData: [],
      editForm: {
        orderid: '',
        ordername: '',
        fileid: '',
        splitFileid: '',
        content: '',
        nextOrderId: '',
        bid: 1,
        files: [],
        imgids: []
      },
      editRules: {
        ordername: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        fileid: [{ required: true, message: '请上传料单', trigger: 'change' }],
        splitFileid: [{ required: true, message: '请导入料单', trigger: 'change' }],
        nextOrderId: [{ required: false, message: '请选择下一拆单订单', trigger: 'change' }],
      },
      nextOrdersLoading: false,
      selectNextOrderList: [],
      editSplitVisible: false,
      editSplitloading: false,
      editSplitForm: {
        orderid: '',
        ordername: '',
        address: '',
        num: 2,
        orderInfo: []
      },
      editSplitRules: {
        ordername: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        num: [{ required: true, message: '请输入拆分个数', trigger: 'blur' }],
        address: [{ required: true, message: '请输入订单地址', trigger: 'blur' }]
      },

      expectSplitVisible: false,
      expectSplitloading: false,
      expectSplitForm: {
        ordername: '',
        orderid: '',
        time: ''
      },
      expectSplitRules: {
        ordername: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        time: [{ required: true, message: '请选择时间', trigger: 'change' }]
      },

      pauseSplitVisible: false,
      pauseSplitLoading: false,
      pauseSplitForm: {
        ordername: '',
        orderid: '',
        nextOrderId: '',
        content: '',
        imgids: []
      },
      pauseSplitRules: {
        ordername: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        content: [{ required: true, message: '请输入备注或上传凭证图片', trigger: 'blur' }],
        imgids: [{ required: true, message: '请输入备注或上传凭证图片', trigger: 'change' }],
        nextOrderId: [{ required: false, message: '请选择下一拆单订单', trigger: 'change' }],
      },

      nextSplitVisible: false,
      nextSplitLoading: false,
      nextSplitForm: {
        nextOrderId: ''
      },
      nextSplitRules: {
        nextOrderId: [{ required: true, message: '请选择正在拆单的订单', trigger: 'change' }],
      },

      searchForm: {
        search: '',
        type: '',
        brandId: ''
      },
      brandList: [],
      error: 0
    }
  },
  computed: {
    user: getUser
  },
  watch: {
    'editForm.fileid': function(newVal) {
      if (!this.istempFile) {
        if (newVal === null || newVal === '' || newVal === undefined) {
          if (this.editForm.splitFileid !== null && this.editForm.splitFileid !== '' && this.editForm.splitFileid !== undefined) {
            this.editForm.splitFileid = ''
          }
        }
      } else {
        this.istempFile = false
      }
      this.error = 0
    }
  },
  created() {
    this.getData()
    this.getBrandList()
    this.getUserSplitInfo()
  },
  methods: {
    tranfromSec(seconds) {
      if (!seconds || seconds <= 0) return '--'
      const d = parseInt(seconds/60/60/24)
      const h = parseInt(seconds/60/60%24)
      const m = parseInt(seconds/60%60)
      const s = parseInt(seconds%60)
      return (d > 0 ? d + '天' : '') + (h > 0 ? h + '小时' : '') + (m > 0 ? m + '分' : '') + s + '秒'
    },
    getBrandList() {
      getBrandList().then(response => {
        this.brandList = response.data
      })
    },
    getUserSplitInfo() {
      getSplitInfo({
        userid: this.user.dUserid
      }).then(response => {
        // 有待拆订单 但没有进行中订单
        if (response && response.data && response.data.can > 0 && response.data.ing == 0) {
          this.nextSplitForm = {
            nextOrderId: ''
          }

          this.getSelectOrders('next', {}, (len) => {
            if (len > 0) this.nextSplitVisible = true
          });
        }
      })
    },
    changeMark(n) {
      if (n === this.mark) {
        return false
      } else {
        this.mark = n
        this.currentPage = 1
        this.getData()
      }
    },
    Search() {
      this.currentPage = 1
      this.searchForm.search = this.searchForm.search.trim()
      this.getData()
    },
    getData() {
      this.loading = true
      const data = {
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        mark: this.mark,
        groupid: this.user.dGroupid,
        userid: this.user.dUserid,
        role: this.user.role,
        type: this.searchForm.type,
        brandId: this.searchForm.brandId,
        chk: this.searchForm.chk,
        iscd: 1
      }
      getOrderList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      this.$router.push({ path: '/work/order/' + row.order_id })
    },
    expect(row) {
      this.expectSplitForm.orderid = row.order_id
      this.expectSplitForm.ordername = row.order_num + ' / ' + row.address

      this.expectSplitVisible = true
    },
    split(row) {
      this.editForm.orderid = row.order_id
      this.editForm.ordername = row.order_num + ' / ' + row.address
      this.editForm.bid = row.brand_id
      this.editForm.content = ''
      this.editForm.nextOrderId = ''
      this.editForm.files = []
      this.editForm.fileid = ''
      this.istempFile = true
      if (row.split_fileid !== null && row.split_fileid !== '' && row.split_fileid !== undefined) {
        this.oldFile = [{ name: row.split_filename, id: row.split_fileid }]
        this.editForm.splitFileid = row.split_fileid
      } else {
        this.oldFile = []
        this.editForm.splitFileid = ''
      }
      this.editForm.imgids = []
      this.btnKey = new Date().getTime()
      this.importKey = new Date().getTime()
      this.fileLoad = new Date().getTime()

      this.getSelectOrders('finish', row, (len) => {
        this.editVisible = true
        this.editRules.nextOrderId[0].required = len > 0
        this.$refs.editForm.clearValidate()
      });
    },
    getSelectOrders(type, row, callback) {
      this.selectNextOrderList = []
      const data = {
        page: 1,
        limit: 9999,
        mark: 6,
        groupid: this.user.dGroupid,
        userid: this.user.dUserid,
        role: this.user.role,
        iscd: 1
      }
      this.nextOrdersLoading = true
      getOrderList(data).then(response => {
        this.nextOrdersLoading = false
        let list = response.data || []
        // 找出可以开始拆单的订单
        if (list.length > 0) {
          let hasChild = false
          // 如果该订单是子单 是否还有其余进行中子单
          if (type === 'finish' && row.splitOrderId) {
            hasChild = list.findIndex(r => r.splitOrderId &&
              r.splitOrderId == row.splitOrderId && r.splitStatus == 1 && r.order_id != row.order_id) > -1
          }
          // splitStatus 0:未开始、1:进行中、2:已暂停、3:待拆单员确认 4:已完成
          list = list.filter(r => {
            if (type === 'next') {
              return r.splitStatus == 0
            }
            let flag1 = (r.splitStatus == 0 || r.splitStatus == 3) && r.order_id != row.order_id
            let flag2 = false
            // 如果是完成操作 且还有其他进行中子单 需要优先完成子单
            if (type === 'finish' && hasChild) {
              flag1 = false
              if (r.splitOrderId && row.splitOrderId) {
                flag2 = r.splitOrderId == row.splitOrderId && r.order_id != row.order_id
              }
            }
            return flag1 || flag2
          })
          // 排序 如果是子单 同子单数据在前
          if (row.splitOrderId && list.length > 0) {
            list.sort((a, b) => {
              return a.splitOrderId == row.splitOrderId ? 1 : 0;
            });
          }
        }
        this.selectNextOrderList = list
        if (callback && typeof callback === 'function') {
          callback(this.selectNextOrderList.length)
        }
      }).catch(() => {
        this.nextOrdersLoading = false
      })
    },
    // 确认开始继续拆单
    start(row) {
      if (row.splitStatus != 3) return
      this.$confirm('是否确认继续拆单 ' + row.order_num + '？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success'
      }).then(() => {
        const data = {
          userid: this.user.dUserid,
          orderid: row.order_id,
          ctype: 104, // 104-继续拆单
        }
        addOrderDynamic(data).then(response => {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.getData()
        }).catch(() => {})
      }).catch(() => {})
    },
    // 暂停拆单
    pause(row) {
      // splitStatus: 1-进行中
      if (row.splitStatus != 1) return
      this.pauseSplitForm = {
        orderid: row.order_id,
        ordername: row.order_num + ' / ' + row.address,
        content: '',
        imgids: []
      }
      this.pauseSplitVisible = true

      this.getSelectOrders('pause', row, (len) => {
        this.pauseSplitVisible = true
        this.pauseSplitRules.nextOrderId[0].required = len > 0
        this.$refs.pauseSplitForm.clearValidate()
      });
    },
    // 开始拆单 初始化
    subSplitNext(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.nextSplitLoading) {
            this.nextSplitLoading = true
            const data = {
              userid: this.user.dUserid,
              orderid: this.nextSplitForm.nextOrderId,
              nextOrderId: this.nextSplitForm.nextOrderId,
              ctype: 100, // 100-开始拆单
            }
            addOrderDynamic(data).then(response => {
              this.$message({
                message: '操作成功',
                type: 'success'
              })
              this.nextSplitLoading = false
              this.nextSplitVisible = false
              this.getData()
            }).catch(() => {
              this.nextSplitLoading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    // 暂停拆单
    subSplitPause(formName) {
      let required = this.pauseSplitForm.content.trim() || this.pauseSplitForm.imgids.length > 0
      this.pauseSplitRules.content[0].required = !required
      this.pauseSplitRules.imgids[0].required = !required
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.pauseSplitLoading) {
            this.pauseSplitLoading = true
            const data = {
              userid: this.user.dUserid,
              orderid: this.pauseSplitForm.orderid,
              nextOrderId: this.pauseSplitForm.nextOrderId,
              content: this.pauseSplitForm.content,
              imgStr: this.pauseSplitForm.imgids.join(','),
              ctype: 101, // 101-暂停拆单
            }
            addOrderDynamic(data).then(response => {
              this.$message({
                message: '操作成功',
                type: 'success'
              })
              this.pauseSplitLoading = false
              this.pauseSplitVisible = false
              this.getData()
            }).catch(() => {
              this.pauseSplitLoading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    // 核对
    check(row) {
      this.$confirm('是否确认已核对订单 ' + row.order_num + '？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = {
          orderid: row.order_id
        }
        chkOrder(data).then(response => {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.getData()
        }).catch(() => {})
      }).catch(() => {})
    },
    importMaterials() {
      if (this.error === 1) {
        this.$message({
          message: '请重新上传料单',
          type: 'warning'
        })
        return false
      }
      if (!this.importloading) {
        this.importloading = true
        const importLoading = this.$loading({
          lock: true,
          text: '料单正在导入，请勿关闭此页面',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        })
        const data = {
          orderid: this.editForm.orderid,
          fileid: this.editForm.fileid,
          userid: this.user.dUserid
        }
        ErpOrderImportMaterial(data).then(response => {
          this.getData()
          this.editForm.splitFileid = this.editForm.fileid
          this.importloading = false
          this.$message({
            message: '料单导入成功',
            type: 'success'
          })
          importLoading.close()
        }).catch(() => {
          this.error = 1
          this.importloading = false
          importLoading.close()
        })
      }
    },
    closeMaterial() {
      this.materialTableData = []
      this.materialVisible = false
    },
    getMaterialDetail() {
      this.materialTableData = []
      this.materialVisible = true
      this.materialloading = true
      getErpOrderMaterialDetail({ orderid: this.editForm.orderid }).then(response => {
        this.materialloading = false
        this.materialTableData = response.data
      }).catch(() => {
        this.materialloading = false
      })
    },
    // objectSpanMethod({ row, column, rowIndex, columnIndex }) {
    //   if (columnIndex === 1) {
    //     let tempindex = 0
    //     let rowspan = 1
    //     let temp = null
    //     for (let i = 0; i <= this.materialTableData.length; i++) {
    //       if (i === 0) {
    //         tempindex = i
    //         rowspan = 1
    //         temp = this.materialTableData[i].area
    //       } else {
    //         if (i === this.materialTableData.length) {
    //           if (rowIndex === tempindex) {
    //             return {
    //               rowspan: rowspan,
    //               colspan: 1
    //             }
    //           }
    //         } else {
    //           if (temp === this.materialTableData[i].area) {
    //             rowspan++
    //             if (rowIndex === i) {
    //               return {
    //                 rowspan: 0,
    //                 colspan: 0
    //               }
    //             }
    //           } else {
    //             if (rowIndex === tempindex) {
    //               return {
    //                 rowspan: rowspan,
    //                 colspan: 1
    //               }
    //             } else {
    //               tempindex = i
    //               rowspan = 1
    //               temp = this.materialTableData[i].area
    //             }
    //           }
    //         }
    //       }
    //     }
    //   }
    // },
    subEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.SubSplitOrder()
        } else {
          return false
        }
      })
    },
    SubSplitOrder() {
      if (!this.editloading) {
        this.editloading = true
        const data = {
          userid: this.user.dUserid,
          orderid: this.editForm.orderid,
          content: this.editForm.content,
          fileids: this.editForm.files.join(','),
          imgids: this.editForm.imgids.join(','),
          nextOrderId: this.editForm.nextOrderId
        }
        splitCarryOrder(data).then(response => {
          this.$message({
            message: '拆单已完成',
            type: 'success'
          })
          this.editloading = false
          this.editVisible = false
          this.getData()
        }).catch(() => {
          this.editloading = false
        })
      } else {
        return false
      }
    },
    splitCf(row) {
      this.editSplitForm.orderid = row.order_id
      this.editSplitForm.ordername = row.order_num + ' / ' + row.address
      this.editSplitForm.num = 2
      this.editSplitForm.address = row.address
      this.editSplitForm.orderInfo = [{ address: this.editSplitForm.address + '（第一批）' }, { address: this.editSplitForm.address + '（第二批）' }]
      this.editSplitVisible = true
    },
    toChinese(values) {
      const chin_list = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十']
      const sn = parseInt(values)
      return chin_list[sn - 1]
    },
    handleSplitChange(val, oldValue) {
      if (val > oldValue) {
        for (let i = oldValue; i < val; i++) {
          this.editSplitForm.orderInfo.push({ address: this.editSplitForm.address + '（第' + this.toChinese(i + 1) + '批）' })
        }
      } else if (val < oldValue) {
        for (let i = this.editSplitForm.orderInfo.length; i > val; i--) {
          this.editSplitForm.orderInfo.splice((i - 1), 1)
        }
      }
    },
    subSplitExpect(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.expectSplitloading) {
            this.expectSplitloading = true
            const data = {
              userid: this.user.dUserid,
              orderid: this.expectSplitForm.orderid,
              time: this.expectSplitForm.time
            }
            expectSplit(data).then(response => {
              this.$message({
                message: '操作成功',
                type: 'success'
              })
              this.expectSplitloading = false
              this.expectSplitVisible = false
              this.getData()
            }).catch(() => {
              this.expectSplitloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    subSplitEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editSplitloading) {
            this.editSplitloading = true
            const names = []
            for (const oi of this.editSplitForm.orderInfo) {
              names.push(oi.address)
            }
            let namesStr = JSON.stringify(names)
            namesStr = namesStr.substring(1, namesStr.length - 1)
            const data = {
              userid: this.user.dUserid,
              orderid: this.editSplitForm.orderid,
              num: this.editSplitForm.num,
              names: namesStr
            }
            orderSplit(data).then(response => {
              this.$message({
                message: '订单拆分成功',
                type: 'success'
              })
              this.editSplitloading = false
              this.editSplitVisible = false
              this.getData()
            }).catch(() => {
              this.editSplitloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    downNewestTemplate() {
      getNewestMaterialTemplate({ bid: this.editForm.bid === 2 ? 1 : this.editForm.bid }).then(response => {
        if (response.data !== null) {
          this.downLoad(response.data)
        } else {
          this.$message({
            type: 'warning',
            message: '暂无最新模板'
          })
        }
      })
    },
    downLoad(row) {
      const _this = this
      const xhr = new XMLHttpRequest()
      xhr.open('GET', row.url, true)
      xhr.responseType = 'blob'
      xhr.onload = function() {
        if (this.status === 200) {
          const blob = this.response
          const a = document.createElement('a')
          a.download = row.fileName
          a.href = window.URL.createObjectURL(blob)
          a.target = '_blank'
          a.click()
          _this.excelLoading = false
          const h = _this.$createElement
          _this.$msgbox({
            title: '下载提示',
            message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
              h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
              h('a',
                { attrs: {
                  href: window.URL.createObjectURL(blob),
                  target: '_blank',
                  download: `${row.fileName}`,
                  style: 'color: #409EFF;text-decoration:underline;'
                }}, `点击这里`),
              h('span', null, `重新下载。`)
            ]),
            showCancelButton: false,
            confirmButtonText: '关闭',
            beforeClose: (action, instance, done) => {
              done()
            }
          }).then(action => {
          })
        }
      }
      xhr.send()
      this.btnLoading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.cd-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}

.view-info {
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  .tit {
    color: #606266;
    display: flex;

    span {
      font-weight: bold;
    }
  }
}
</style>
